import React from 'react';

const MessageThread = ({ msg }: any) => {
  return (
    <>
      {msg.type === 'sent' ? (
        <div className="flex max-w-[80%] flex-col justify-end self-end lg:max-w-[50%]">
          <div className="mb-2 flex justify-between gap-6">
            <p className="m-0 text-[14px] lg:text-[16px]">You</p>
            <p className="m-0 text-[14px] lg:text-[16px]">{msg.time}</p>
          </div>
          <div className="mb-4 rounded-[5px] border border-[#1974c7cc] bg-[#1974c7cc] p-3 text-[14px] text-white lg:text-[16px]">
            {msg.text}
          </div>
        </div>
      ) : (
        <div className="flex max-w-[80%] flex-col justify-start self-start lg:max-w-[50%]">
          <div className="mb-2 flex justify-between gap-6">
            <p className="m-0 text-[14px] lg:text-[16px]">{msg.sender}</p>
            <p className="m-0 text-[14px] lg:text-[16px]">{msg.time}</p>
          </div>
          <div className="borde mb-4 rounded-[5px] bg-[#f2f4f7] p-3 text-[14px] lg:text-[16px]">
            {msg.text}
          </div>
        </div>
      )}
    </>
  );
};

export default MessageThread;
